import { AiOutlineInfo } from "react-icons/ai";
import Button from "../../../../../atoms/Button";
import CardHeader from "../../../../../atoms/CardHeader";
import Breadcrumb from "../../../../../molecules/Breadcrumb";
import useModal from "../../../../../../hooks/useModal";
import Modal from "../../../../../molecules/Modal";
import InfoEmpresa from "../../../../../templates/clientes/InfoEmpresa";
import { MdAdd } from "react-icons/md";
import ModalAddCaso from "../../../../DF/casos/ModalAddCaso";

const DFHeader = ({ empresa, refetch, user }) => {
    const { open: openInfo, close, isOpen } = useModal();
    const { open: openAdd, close: closeAdd, isOpen: isOpenAdd } = useModal();

    return(
        <CardHeader>
            <Breadcrumb
                items={[
                    { label: `${empresa?.name || "cargando..."}`, to: `/clientes/empresas/${empresa?.id}/decide` },
                    { label: "DEFENSA FISCAL", to: `/clientes/empresas/${empresa?.id}/decide` },
                ]}
            />
            <div className="flex flex-row gap-2">
                {user && user.role !== "Client" &&
                    <Button
                        text={<MdAdd size={22} />}
                        bgColor="green"
                        width="w-10"
                        onClick={openAdd}
                    />
                }
                <Button
                    text={<AiOutlineInfo size={22} />}
                    bgColor="black"
                    width="w-10"
                    onClick={openInfo}
                />
            </div>
            {isOpen && empresa &&
                <Modal title="Información" onClose={close}>
                    <InfoEmpresa empresa={empresa} />
                </Modal>
            }
            {isOpenAdd &&
                <Modal title="Agregar nuevo caso" onClose={closeAdd}>
                    <ModalAddCaso onClose={closeAdd} refetch={refetch} empresaId={empresa.id} />
                </Modal>
            }
        </CardHeader>
    );
}

export default DFHeader;